export default __webpack_public_path__ + "static/media/SXP.76c25002.svg";